import React from 'react';
import SourceFieldset from '@/features/quickSetup/SourceFieldset';
import TemplateSelector from '@/features/quickSetup/TemplateSelector';
import WizardFormLayout from '@/features/quickSetup/WizardFormLayout';
import type { QuickSetupFormState } from '@/features/quickSetup/types';
import type { Source } from '@/types';

type Props = {
  form: QuickSetupFormState;
  sources: Source[];
  onChange: (patch: Partial<QuickSetupFormState>) => void;
  onToggleSource: (name: string) => void;
  onSetSourceNames?: (names: string[]) => void;
  sourcesEmptyHint?: string;
};

export default function RealEstateWizard({
  form,
  sources,
  onChange,
  onToggleSource,
  onSetSourceNames,
  sourcesEmptyHint,
}: Props) {
  return (
    <WizardFormLayout
      aside={
        <>
          <TemplateSelector category="real_estate" form={form} onApply={onChange} />
          <SourceFieldset
            sources={sources}
            selected={form.source_names}
            onToggle={onToggleSource}
            onSetSelected={onSetSourceNames}
            emptyHint={sourcesEmptyHint}
          />
        </>
      }
    >
      <div className="wizard-field-grid">
        <label className="wizard-field-span-2">
          Search text
          <input
            value={form.search_text}
            onChange={(e) => onChange({ search_text: e.target.value })}
            placeholder="apartment, house, land…"
          />
        </label>

        <label>
          City
          <input
            value={form.city}
            onChange={(e) => onChange({ city: e.target.value })}
            placeholder="Split"
          />
        </label>

        <label>
          Region
          <input
            value={form.region}
            onChange={(e) => onChange({ region: e.target.value })}
            placeholder="Dalmatia"
          />
        </label>

        <label>
          Price min (EUR)
          <input
            type="number"
            value={form.price_min}
            onChange={(e) => onChange({ price_min: e.target.value })}
          />
        </label>
        <label>
          Price max (EUR)
          <input
            type="number"
            value={form.price_max}
            onChange={(e) => onChange({ price_max: e.target.value })}
          />
        </label>

        <label>
          Area m² min
          <input
            type="number"
            value={form.area_min}
            onChange={(e) => onChange({ area_min: e.target.value })}
          />
        </label>
        <label>
          Area m² max
          <input
            type="number"
            value={form.area_max}
            onChange={(e) => onChange({ area_max: e.target.value })}
          />
        </label>

        <label>
          Rooms min
          <input
            type="number"
            value={form.rooms_min}
            onChange={(e) => onChange({ rooms_min: e.target.value })}
          />
        </label>
        <label>
          Rooms max
          <input
            type="number"
            value={form.rooms_max}
            onChange={(e) => onChange({ rooms_max: e.target.value })}
          />
        </label>

        <fieldset className="property-type-field wizard-field-span-2">
          <legend>Property type</legend>
          <div className="property-type-options">
            <label className="checkbox">
              <input
                type="radio"
                name="property_type"
                checked={form.property_type === 'apartment'}
                onChange={() => onChange({ property_type: 'apartment' })}
              />
              Apartment
            </label>
            <label className="checkbox">
              <input
                type="radio"
                name="property_type"
                checked={form.property_type === 'house'}
                onChange={() => onChange({ property_type: 'house' })}
              />
              House
            </label>
            <label className="checkbox">
              <input
                type="radio"
                name="property_type"
                checked={form.property_type === ''}
                onChange={() => onChange({ property_type: '' })}
              />
              Any
            </label>
          </div>
        </fieldset>
      </div>
    </WizardFormLayout>
  );
}
